import { gsap } from "@gsap";

/**
 * Layout: Home Intro Verhaal
 * Slug: home_intro_story
 */

// Per path, in SVG units: the direction each segment comes from
const offsets = [
    { x: 110, y: 90 },
    { x: 140, y: -60 },
    { x: 20, y: -150 },
    { x: -140, y: 0 },
    { x: 100, y: 130 },
    { x: -40, y: 150 },
    { x: -130, y: -60 },
];

const initStoryAnimations = () => {
    document.querySelectorAll(".flex-layout.home_intro_story-layout").forEach((layout) => {
        const image = layout.querySelector(".image-col img");
        const imageCol = layout.querySelector(".image-col");

        // Slight scrubbed drift against the shape; stays still under reduced motion
        if (image && imageCol) {
            gsap.matchMedia().add(
                {
                    desktop: "(min-width: 993px) and (prefers-reduced-motion: no-preference)",
                },
                (context) => {
                    const drift = context.conditions.desktop ? 40 : 20;

                    gsap.fromTo(
                        image,
                        { y: -drift },
                        {
                            y: drift,
                            ease: "none",
                            scrollTrigger: {
                                trigger: imageCol,
                                start: "top bottom",
                                end: "bottom top",
                                scrub: 0.6,
                            },
                        },
                    );
                },
            );
        }
    });
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initStoryAnimations, { once: true });
} else {
    initStoryAnimations();
}
